module.exports = __webpack_public_path__ + "img/sa.60d4e15e.svg";